import { render, staticRenderFns } from "./PPrefectureSearchFilter.vue?vue&type=template&id=51bf1506&scoped=true&"
import script from "./PPrefectureSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./PPrefectureSearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./PPrefectureSearchFilter.vue?vue&type=style&index=0&id=51bf1506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf1506",
  null
  
)

export default component.exports